import React from 'react';
import Image from '@sls-react/components/Image';
import ArrowRightIcon from '@sls-react/static/svg/ArrowRightIcon';
import classNames from 'classnames';

interface Props {
  className?: any;
  onClick?: React.MouseEventHandler;
  title: string;
}

// This is pretty much the exact same as UnlimitedTileBase.tsx, but should never have an image.

const UnlimitedTitleTile: React.FC<Props> = ({ className, onClick, title }) => (
  <button
    className={classNames(
      'p-2 border rounded shadow md:flex w-full md:items-center md:px-4 border-grey-200 hover:shadow-md transition-shadow duration-300',
      className,
    )}
    onClick={onClick}
  >
    <div className="block mt-2 text-sm font-semibold text-center md:text-left md:mt-0">
      {title}
    </div>

    <div className="md:mr-auto" />

    <ArrowRightIcon className="hidden md:block" />
  </button>
);

export default UnlimitedTitleTile;
